import React, { useState, useMemo } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Row,
  Col,
  Card,
  Divider
} from '@lockerpm/design';

import paymentComponents from './payment/index';
import common from "../../../../utils/common";

import dayjs from 'dayjs';

const PlanPayment = (props) => {
  const { t } = useTranslation();
  const {
    PlanReview,
    FamilyMembers,
    CardSelect,
    PayAndUpgrade,
    PayResultModal
  } = paymentComponents;

  const {
    className = '',
    planPeriod = {},
    planTypes = {},
    selectedPeriod = {},
    selectedPlan = {},
    onSwitchPlan = () => { },
    setSelectedPlanDuration = () => { }
  } = props;

  const locale = useSelector((state) => state.system.locale);

  const [familyMembers, setFamilyMembers] = useState([]);
  const [selectedCard, setSelectedCard] = useState({});
  const [result, setResult] = useState({});
  const [resultVisible, setResultVisible] = useState(false);

  const discountPercentage = useMemo(() => {
    const percentage = result.discount * 100 / result.total_price
    if (!Number.isNaN(percentage)) {
      return Math.round(percentage)
    }
    return 0
  }, [result])

  const nextBill = useMemo(() => {
    const now = new Date().getTime()
    if (result.next_billing_time) {
      return common.convertDateTime(result.next_billing_time, 'DD MMM YYYY')
    }
    if (result.duration === planPeriod.YEARLY) {
      return dayjs(now).add(1, 'year').format('DD MMM YYYY');
    }
    return dayjs(now).add(1, 'month').format('DD MMM YYYY');
  }, [result, locale])

  return (
    <div className={className}>
      <p className="text-xl font-semibold">
        {t('manage_plans.payment')}
      </p>
      <p className="">
        {t('manage_plans.choose_payment_method')}
      </p>
      <div className="mt-4">
        <Row gutter={[24, 24]}>
          <Col xl={16} lg={14} span={24}>
            <Card
              className="mb-4"
              title={
                <p className="text-[18px] font-semibold">
                  {t('manage_plans.payment_step.step_1')}
                </p>
              }
            >
              <PlanReview
                planTypes={planTypes}
                planPeriod={planPeriod}
                selectedPeriod={selectedPeriod}
                selectedPlan={selectedPlan}
                onSwitchPlan={onSwitchPlan}
                setSelectedPlanDuration={setSelectedPlanDuration}
              />
              {
                selectedPlan.alias === planTypes.FAMILY && <>
                  <Divider />
                  <FamilyMembers
                    familyMembers={familyMembers}
                    setFamilyMembers={setFamilyMembers}
                  />
                </>
              }
            </Card>
            <CardSelect
              result={result}
              selectedCard={selectedCard}
              setSelectedCard={setSelectedCard}
            />
          </Col>
          <Col xl={8} lg={10} span={24}>
            <PayAndUpgrade
              planTypes={planTypes}
              planPeriod={planPeriod}
              selectedPeriod={selectedPeriod}
              selectedPlan={selectedPlan}
              familyMembers={familyMembers}
              selectedCard={selectedCard}
              result={result}
              discountPercentage={discountPercentage}
              nextBill={nextBill}
              setResult={setResult}
              onDone={() => setResultVisible(true)}
            />
          </Col>
        </Row>
      </div>
      <PayResultModal
        visible={resultVisible}
        selectedPeriod={selectedPeriod}
        selectedPlan={selectedPlan}
        result={result}
        selectedCard={selectedCard}
        discountPercentage={discountPercentage}
        nextBill={nextBill}
        onClose={() => setResultVisible(false)}
      />
    </div>
  );
}

export default PlanPayment;